import { render } from "./AlteriConnectionList.vue?vue&type=template&id=c257ce52&scoped=true&ts=true"
import script from "./AlteriConnectionList.vue?vue&type=script&lang=ts"
export * from "./AlteriConnectionList.vue?vue&type=script&lang=ts"

import "./AlteriConnectionList.vue?vue&type=style&index=0&id=c257ce52&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c257ce52"]])

export default __exports__